import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_idprint } from "../shared/data.service";

import { wsPrintQueueInfo } from "../shared/wsPrintQueueInfo";
import { wsPrintQueuePrintReleasedStockInfo } from "../shared/wsPrintQueuePrintReleasedStockInfo";
import { wsPrintQueuePrintFiltersAcademyInfo } from "../shared/wsPrintQueuePrintFiltersInfo";
import { wsPrintQueuePrintFiltersHomeroomInfo } from "../shared/wsPrintQueuePrintFiltersInfo";
import { wsPrintQueuePrintFiltersGradeLevelInfo } from "../shared/wsPrintQueuePrintFiltersInfo";
import { wsPrintQueuePrintParm } from "../shared/wsPrintQueuePrintParm";
import { wsPrintInfo } from "../shared/wsPrintQueuePrintParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./print.component.html",
	styleUrls: ["./print.component.css"],
})
export class PrintComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_idprint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isStaffMode: boolean = false;

	public lstPrintQueueChecked: wsPrintQueueInfo[] = [];
	public lstPrintQueueReleasedStock: wsPrintQueuePrintReleasedStockInfo[] = [];
	public lstPrintItems: wsPrintQueueInfo[] = [];

	public lstSortOrder: any = [];
	public lstAcademy: wsPrintQueuePrintFiltersAcademyInfo[] = [];
	public lstHomeroom: wsPrintQueuePrintFiltersHomeroomInfo[] = [];
	public lstGradeLevel: wsPrintQueuePrintFiltersGradeLevelInfo[] = [];

	public SelectedSortOrder: any;
	public SelectedAcademy: wsPrintQueuePrintFiltersAcademyInfo;
	public SelectedHomeroom: wsPrintQueuePrintFiltersHomeroomInfo;
	public SelectedGradeLevel: wsPrintQueuePrintFiltersGradeLevelInfo;

	public SchoolID: number = 0;
	public ErrorMessage: string = "";
	public StockInUseDesc: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.lstPrintQueueChecked = this.dialogConfig.data.lstPrintQueueChecked;

		//
		//	The list will only contain all Staff or all Students
		//
		if (this.lstPrintQueueChecked[0].IsStaff == true) {
			this.isStaffMode = true;
		} else {
			this.isStaffMode = false;
		}

		this.isBusy = true;
		this.dataService.IDPrintQueueSelectReleasedBySchool(this.SchoolID).subscribe((data) => this.IDPrintQueueSelectReleasedBySchool_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	SetDropDowns
	//
	//-----------------------------------------------------------------------------------------------------
	SetDropDowns() {
		//
		//	Clear Lists
		//
		this.lstSortOrder = [];
		this.lstAcademy = [];
		this.lstGradeLevel = [];
		this.lstHomeroom = [];

		let rSort: any;

		rSort = { SortID: 1, SortDesc: "Name" };
		this.lstSortOrder.push(rSort);

		if (this.isStaffMode == false) {
			rSort = { SortID: 2, SortDesc: "Academy" };
			this.lstSortOrder.push(rSort);

			rSort = { SortID: 3, SortDesc: "Grade" };
			this.lstSortOrder.push(rSort);

			rSort = { SortID: 4, SortDesc: "Homeroom" };
			this.lstSortOrder.push(rSort);
		}

		this.SelectedSortOrder = this.lstSortOrder[0];

		//
		//	Fill Lists
		//
		var lstAcademylWork = [];
		var lstGradeLevelWork = [];
		var lstHomeroomlWork = [];

		this.lstPrintQueueChecked.forEach((item) => {
			if (item.IsStaff == false) {
				let a: wsPrintQueuePrintFiltersAcademyInfo = {
					AcademyID: item.AcademyID,
					AcademyDesc: item.AcademyDesc,
				};

				let hr: wsPrintQueuePrintFiltersHomeroomInfo = {
					HomeroomID: item.HomeroomID,
					Homeroom: item.Homeroom,
				};

				let gl: wsPrintQueuePrintFiltersGradeLevelInfo = {
					GradeLevelID: item.GradeLevelID,
					GradeLevelDesc: item.GradeLevelDesc,
				};

				lstAcademylWork.push(a);
				lstHomeroomlWork.push(hr);
				lstGradeLevelWork.push(gl);
			}
		});

		var lstAcademylWork2: wsPrintQueuePrintFiltersAcademyInfo[] = [];
		var lstHomeroomlWork2: wsPrintQueuePrintFiltersHomeroomInfo[] = [];
		var lstGradeLevelWork2: wsPrintQueuePrintFiltersGradeLevelInfo[] = [];

		//
		// Distinct Academy
		//
		lstAcademylWork.forEach(function (item) {
			var i = lstAcademylWork2.findIndex((x) => x.AcademyID == item.AcademyID);

			if (i <= -1) {
				lstAcademylWork2.push({
					AcademyID: item.AcademyID,
					AcademyDesc: item.AcademyDesc,
				});
			}
		});

		//
		//	Sort
		//
		lstAcademylWork2.sort((a, b) => (a.AcademyDesc > b.AcademyDesc ? 1 : -1));
		this.lstAcademy = lstAcademylWork2;

		//
		// Distinct Homeroom
		//
		lstHomeroomlWork.forEach(function (item) {
			var i = lstHomeroomlWork2.findIndex((x) => x.HomeroomID == item.HomeroomID);

			if (i <= -1) {
				lstHomeroomlWork2.push({
					HomeroomID: item.HomeroomID,
					Homeroom: item.Homeroom,
				});
			}
		});

		//
		//	Sort
		//
		lstHomeroomlWork2.sort((a, b) => (a.Homeroom > b.Homeroom ? 1 : -1));
		this.lstHomeroom = lstHomeroomlWork2;

		//
		// Distinct Grade Level
		//
		lstGradeLevelWork.forEach(function (item) {
			var i = lstGradeLevelWork2.findIndex((x) => x.GradeLevelID == item.GradeLevelID);

			if (i <= -1) {
				lstGradeLevelWork2.push({
					GradeLevelID: item.GradeLevelID,
					GradeLevelDesc: item.GradeLevelDesc,
				});
			}
		});

		//
		//	Sort
		//
		lstGradeLevelWork2.sort((a, b) => (a.GradeLevelDesc > b.GradeLevelDesc ? 1 : -1));
		this.lstGradeLevel = lstGradeLevelWork2;

		//
		//	Set The ALL Selection
		//
		this.lstAcademy.unshift({
			AcademyID: -1,
			AcademyDesc: "ALL",
		});

		this.SelectedAcademy = this.lstAcademy[0];

		this.lstHomeroom.unshift({
			HomeroomID: -1,
			Homeroom: "ALL",
		});

		this.SelectedHomeroom = this.lstHomeroom[0];

		this.lstGradeLevel.unshift({
			GradeLevelID: -1,
			GradeLevelDesc: "ALL",
		});

		this.SelectedGradeLevel = this.lstGradeLevel[0];
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSelectReleasedBySchool_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSelectReleasedBySchool_Complete(data: any) {
		this.lstPrintQueueReleasedStock = data;

		if (this.lstPrintQueueReleasedStock.length > 0) {
			this.StockInUseDesc = this.lstPrintQueueReleasedStock[0].IDCardStockDesc;
		} else {
			this.StockInUseDesc = "";
		}

		this.SetDropDowns();
		this.onSetPrintItemsList();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSortOrderChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSortOrderChange(value) {
		this.SelectedSortOrder = value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAcademyChange
	//
	//-----------------------------------------------------------------------------------------------------
	onAcademyChange(value) {
		this.SelectedAcademy = value;
		this.onSetPrintItemsList();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHomeroomChange
	//
	//-----------------------------------------------------------------------------------------------------
	onHomeroomChange(value) {
		this.SelectedHomeroom = value;
		this.onSetPrintItemsList();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onGradeLevelChange
	//
	//-----------------------------------------------------------------------------------------------------
	onGradeLevelChange(value) {
		this.SelectedGradeLevel = value;
		this.onSetPrintItemsList();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetPrintItemsList
	//
	//-----------------------------------------------------------------------------------------------------
	onSetPrintItemsList() {
		var lstPrintItemsWork = [];

		//
		//	Filters are only for students
		//
		if (this.isStaffMode == true) {
			lstPrintItemsWork = this.lstPrintQueueChecked;
		} else {
			var lstFilterWork1 = [];
			var lstFilterWork2 = [];
			var lstFilterWork3 = [];

			var AcademyID: Number = this.SelectedAcademy.AcademyID;
			var HomeroomID: Number = this.SelectedHomeroom.HomeroomID;
			var GradeLevelID: Number = this.SelectedGradeLevel.GradeLevelID;

			//
			//	Academy
			//
			if (this.SelectedAcademy.AcademyID > -1) {
				lstFilterWork1 = this.lstPrintQueueChecked.filter(function (obj) {
					return obj.AcademyID == AcademyID;
				});
			} else {
				lstFilterWork1 = this.lstPrintQueueChecked;
			}

			//
			//	Homeroom
			//
			if (this.SelectedHomeroom.HomeroomID > -1) {
				lstFilterWork2 = lstFilterWork1.filter(function (obj) {
					return obj.HomeroomID == HomeroomID;
				});
			} else {
				lstFilterWork2 = lstFilterWork1;
			}

			//
			//	GradeLevel
			//
			if (this.SelectedGradeLevel.GradeLevelID > -1) {
				lstFilterWork3 = lstFilterWork2.filter(function (obj) {
					return obj.GradeLevelID == GradeLevelID;
				});
			} else {
				lstFilterWork3 = lstFilterWork2;
			}

			//
			//	FINAL
			//
			lstPrintItemsWork = lstFilterWork3;
		}

		//
		//	Filter out Card Stock if stock is loaded in printer and the stock does not match
		//
		if (this.lstPrintQueueReleasedStock.length > 0) {
			var IDCardStockID: Number = this.lstPrintQueueReleasedStock[0].IDCardStockID;

			this.lstPrintItems = lstPrintItemsWork.filter(function (obj) {
				return obj.IDCardStockID == IDCardStockID;
			});
		} else {
			this.lstPrintItems = lstPrintItemsWork;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		let parms: wsPrintQueuePrintParm = {
			SortID: this.SelectedSortOrder.SortID,
			SortDesc: this.SelectedSortOrder.SortDesc,
			PrintItems: [],
		};

		this.lstPrintItems.forEach((item) => {
			let r: wsPrintInfo = {
				IDPrintQueueID: item.IDPrintQueueID,
				LastName: item.LastName,
				FirstName: item.FirstName,
				AcademyDesc: item.AcademyDesc,
				Homeroom: item.Homeroom,
				GradeLevelDesc: item.GradeLevelDesc,
			};

			parms.PrintItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueuePrint(parms).subscribe((data) => this.IDPrintQueuePrint_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueuePrint_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueuePrint_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
